export function rgba2hex(rgba: string): string | null {
  rgba = rgba.replace(/\s/g, '');
  const regex = /^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i;
  const parsed = regex.exec(rgba);

  if (!parsed) {
    return rgba;
  }
  const red = parsed[1];
  const green = parsed[2];
  const blue = parsed[3];
  const alpha = parsed[4];
  try {
    const elems = [hex(red), hex(green), hex(blue)];
    if (alpha) {
      elems.push(hex(alpha));
    }
    return `#${elems.join('')}`;
  } catch (e) {
    return null;
  }
}

function hex(number: number | string | undefined) {
  if (number === undefined) {
    return;
  }
  if (number > 255) {
    throw `'${number}'' is greater than 255(0xff);`;
  }
  const str = Number(number).toString(16);

  return `0${str}`.slice(-2);
}
